import {mapGetters} from 'vuex'
export default {
  computed: {
    ...mapGetters({currentRole: 'authentication/currentRole'}),
    isReadOnly() {
      const {meta} = this.$route
      const {readOnlyRoles} = meta

      if (readOnlyRoles) {
        return readOnlyRoles.includes(this.currentRole)
      }

      return false
    },
  },
}
